import React from 'react';
import searchIcon from '../images/search.svg'

const SearchBar = ({ searchTerm, onSearchChange, onOpenEventModal}) => (
    <div className="col-12 col-lg-10 col-md-10 mb-2 mb-md-0 d-flex justify-content-center">
        <input
            type="text"
            className="form-control search-input"
            placeholder="Search..."
            value={searchTerm}
            onChange={onSearchChange}
        />
        <img src={searchIcon} alt='search_icon' className='search_icon'/>
    </div>
);

export default SearchBar;
